import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Card } from '@pretamanger/component-library'

export const ProductListWrapper = styled('div')``

export const CardContainer = styled('div')`
  ${tw`w-full flex justify-start flex-wrap`}
`

export const ContainerTitle = styled('div')`
  ${tw`mb-4 pr-2`}
`

export const ProductCard = styled(Card)`
  ${tw`cursor-pointer`}
  ${tw`w-full flex-grow-0 flex-shrink-0 sm:w-1/2 lg:w-1/2 xl:w-1/3 pb-6`}
`

export const CardLink = styled('a')`
  ${tw`no-underline inline-block`}
`
